import { MutationTree } from 'vuex';
import { HikariState } from '@/store/Hikari/state';

const mutations: MutationTree<HikariState> = {
  // ルータレンタル
  router: (state, value: string) => {
    state.router = value;
  },
  // 光電話オプション
  phoneOptions: (state, value: any) => {
    state.phoneOptions = value;
  },
  // 光電話プラン
  phonePlan: (state, value: string) => {
    // 光でんわのコースを変更する場合は同時にオプションの選択をクリアする
    if (state.phonePlan !== value) {
      state.phoneOptions = [];
    }
    state.phonePlan = value;
  },
  // 建物タイプ
  building: (state, value: string) => {
    // ライフサイクルの関係でご利用中の光回線が光回線再利用の場合の判定を再度行う。
    if (state.entryType === 'reuse') {
      state.building = 'family';
    } else {
      state.building = value;
    }
  },
  // ご利用中の光回線
  entryType: (state, value: string) => {
    if (state.entryType !== value) {
      // ご利用中の光回線についての選択を変更する際、変更先が回線新規で申込タイプが1Gの場合、同時にルータの選択をクリアする
      if (value === 'new' && state.applyType === '1g') {
        state.router = '';
      }
      state.currentUsageType = '';
    }
    if (value === '10g') {
      state.staticIp = 'none';
    }
    // 光回線再利用が選択された場合、建物タイプをファイミリータイプに変更する
    if (value === 'reuse') {
      state.building = 'family';
    }
    state.entryType = value;
  },
  // 固定IP
  staticIp: (state, value: string) => {
    state.staticIp = value;
  },
  // 現在ご利用中の回線タイプ
  currentUsageType: (state, value: string) => {
    if (value === '10g') {
      state.applyType = '10g';
      state.staticIp = 'none';
    }
    state.currentUsageType = value;
  },
  // 申込タイプ
  applyType: (state, value: string) => {
    if (state.applyType !== value) {
      state.router = '';
    }
    if (value === '10g') {
      state.staticIp = 'none';
    }
    state.applyType = value;
  },
};

export default mutations;
